<template>
  <div class="q-pa-md full-height">
    <div class="new-area row">
      <div class="align-right col-12">
        <button tabindex="0" @click="openDialog()" type="button" class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
          <span class="q-focus-helper"></span>
            <span class="q-btn__wrapper col row q-anchor--skip">
              <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                <i aria-hidden="true" role="presentation" class="q-icon notranslate material-icons q-pr-md jt-data-table-button photos-btn">add_to_photos</i>
                {{ $gettext("NEW") }}
              </span>
          </span>
        </button>
      </div>
    </div>
    <q-scroll-area class="form-area">
      <q-list class="rounded-borders" v-if="collectionPoints && collectionPoints.length > 0">
        <q-expansion-item
          v-for="(item, index) in collectionPoints"
          :key="item.id"
          :label="item.name.toUpperCase() + ' - ' + showAreaCode(item)"
          header-class="bg-dark text-white"
          expand-icon-class="text-white"
          class="q-mb-sm collection-points"
          >
          <q-card>
            <q-card-section class="row card-row" >
              <div class="col-12">
                <crud-layout
                  ref="crudLayout"
                  :name="'name'"
                  :interface="'registrarPorCliente'"
                  :id="154"
                />
              </div>
              <div class="row col-12">
                <div class="col-4 text-bold">
                  <q-icon name="contacts" size="1.5em" color="negative" class="q-mr-xs"/>
                  {{getValueDetail("name", item)}}
                </div>
                <div class="col-8">
                  <q-icon name="location_on" size="1.5em" color="negative" class="q-mr-xs"/>
                  {{getAddress(item)}}
                </div>
              </div>
              <div class="row col-12">
                <div class="col-8">
                  <label class="text-bold">{{ getLabelDetail("companyName") }}:</label>
                  {{getValueDetail("companyName", item)}}
                </div>
                <div class="col-4">
                  <label class="text-bold">{{ getLabelDetail("document") }}:</label>
                  {{getValueDetail("document", item)}}
                </div>
              </div>
              <div class="row col-12">
                <div class="col-4">
                  <label class="text-bold">{{ getLabelDetail("stateRegistration") }}:</label>
                  {{getValueDetail("stateRegistration", item)}}
                </div>
                <div class="col-4">
                  <label class="text-bold">{{ getLabelDetail("municipalRegistration") }}:</label>
                  {{getValueDetail("municipalRegistration", item)}}
                </div>
                <div class="col-4">
                  <label class="text-bold">{{ getLabelDetail("organizationalStructure") }}:</label>
                  {{getValueDetail("organizationalStructure", item)}}
                </div>
              </div>
              <div class="row col-12">
                <label class="text-bold">{{ getLabelDetail("phone") }}:</label>
                  {{ getPhones(item) }}
                  <div style="display: flex; gap: 5px; margin-left: auto;">
                    <button
                      class="mdi mdi-pencil mdi-20px custom-cursor no-border"
                      @click="setCollectionPointToUpdatePage(index)">
                    </button>
                    <button
                      class="mdi mdi-delete mdi-20px custom-cursor no-border"
                      @click="removeCollectionPoint(index)">
                    </button>
                  </div>
              </div>
            </q-card-section>
          </q-card>
        </q-expansion-item>
      </q-list>
      <jt-empty-message v-else :message="$gettext('NO_COLLECTION_POINTS')" size="10em" />
    </q-scroll-area>
    <div class="row full-width q-col-gutter-lg justify-center q-py-lg" v-if="forms[0] && forms[0].buttons.length > 0">
        <div v-for="(button, i) in forms[0].buttons" :key="i" class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="info" @click="actionButton(button)">
            <q-icon
                v-if="button.icon"
                :name="button.icon"
                size="18px"
                class="position-icon-filter"
            />
            {{ button.label }}
            </q-btn>
        </div>
    </div>
    <q-dialog v-if="flModal" v-model="flModal">
      <q-layout
        view="Lhh lpR fff"
        container
        class="bg-white modal-medium"
      >
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("COLLECTION_POINT")
            }}</q-toolbar-title>
            <q-btn
              @click="resetCollectionPointToLastSave"
              flat
              round
              dense
              size="1.5em"
              icon="cancel"
            />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <collectionPointRegisterForm :client="client" :nmInterface="'collectionPoint.registrarNovo'" :updateCollectionPoint="updateCollectionPoint" @confirm="addCollectionPoint($event)" @savingUpdateCollectionPoint="savingUpdateCollectionPoint" ></collectionPointRegisterForm>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtEmptyMessage } from 'jtech-webcomps'
import CollectionPointRegisterForm from './CollectionPointRegisterFormPage.vue'
const { page } = JtCrud
import { messageBox } from 'jtech'

@Component({
  mixins: [page],
  name: 'CollectionPointRegisterPage',
  components: {
    JtEmptyMessage,
    CollectionPointRegisterForm
  },
  props: {
    collectionPoints: [],
    client: {}
  }
})
class CollectionPointRegisterPage extends Vue {
  inputs = [];
  flModal = false;
  updateCollectionPoint = {}
  areaCodeList = []

  mounted () {
  }

  beforeMount () {
    this.inputs = this.forms[0].inputs[0].columns
  }

  openDialog () {
    this.flModal = true
  }

  closeDialog () {
    this.flModal = false
  }

  getLabelDetail (name) {
    return this.inputs.find(x => x.field === name).label
  }

  getValueDetail (atribute, object) {
    return (object[atribute] ? object[atribute] : '')
  }

  getPhones (object) {
    const phone = this.getValueDetail('phone', object)
    const phoneAlternative = this.getValueDetail('phoneAlternative', object)
    if (phone && phoneAlternative) {
      return `${phone} - ${phoneAlternative}`
    } else if (phone) {
      return phone
    } else if (phoneAlternative) {
      return phoneAlternative
    }
    return ''
  }

  showAreaCode (item) {
    return (item.areaCode = item.areaCode ? item.areaCode : this.$gettext('NO_AREA_CODE').toUpperCase())
  }

  getAddress (object) {
    return `${this.getValueDetail('addressName', object)} - 
    ${this.getValueDetail('addressNumber', object)} -
    ${this.getValueDetail('addressDetail', object)} - 
    CEP: ${this.getValueDetail('addressZipCode', object)} `
  }

  async addCollectionPoint (collectionPoint) {
    if (!this.collectionPoints) this.collectionPoints = []
    if (this.isAreaCodeUniqueInsideObject(collectionPoint)) {
      return
    }
    this.collectionPoints.push(this.createCollectionPoint(collectionPoint))
    this.$emit('addCollectionPoint', this.collectionPoints)
    this.updateCollectionPoint = {}
    this.closeDialog()
  }

  isAreaCodeUniqueInsideObject = (collectionPoint, index) => {
    if (this.collectionPoints.some((x, ind) => x.areaCode === collectionPoint.areaCode && (index !== ind))) {
      messageBox.warn(this.$gettext('AREA_CODE_ALREADY_REGISTERED'))
      return true
    }
    return false
  }

  createCollectionPoint (collectionPoint) {
    return {
      id: null,
      integrationCode: null,
      available: true,
      name: collectionPoint.name,
      addressName: collectionPoint.addressName,
      addressZipCode: collectionPoint.addressZipCode,
      addressNumber: collectionPoint.number,
      addressDetail: collectionPoint.detail,
      addressNeighborhood: collectionPoint.addressNeighborhoodName,
      companyName: this.client.personName,
      document: this.client.personDocument,
      stateRegistration: collectionPoint.addressNeighborhoodCityStateName,
      municipalRegistration: collectionPoint.addressNeighborhoodCityName,
      organizationalStructure: null,
      phone: this.client.personPhone,
      phoneAlternative: this.client.personAlternativePhone,
      latitude: collectionPoint.latitude,
      longitude: collectionPoint.longitude,
      areaCode: collectionPoint.areaCode
    }
  }

  async actionButton (button, params, page) {
    this.$emit('action-button', button, params, page)
  }

  setCollectionPointToUpdatePage (index) {
    this.updateCollectionPoint = { ...this.collectionPoints[index] }
    this.updateCollectionPoint.index = index
    this.flModal = true
  }

  savingUpdateCollectionPoint (collectionPoint, index) {
    if (this.isAreaCodeUniqueInsideObject(collectionPoint, index)) {
      return
    }
    this.collectionPoints.splice(index, 1, this.createCollectionPoint(collectionPoint))
    this.updateCollectionPoint = {}
    this.closeDialog()
  }

  resetCollectionPointToLastSave () {
    this.closeDialog()
    if (this.updateCollectionPoint && Object.keys(this.updateCollectionPoint).length > 0) {
      this.collectionPoints.filters(x => x.areaCode !== this.updateCollectionPoint.areaCode)
      this.collectionPoints.push(this.updateCollectionPoint)
    }
  }

  removeCollectionPoint (index) {
    this.collectionPoints.splice(index, 1)
    this.updateCollectionPoint = {}
    this.$emit('removeCollectionPoint', this.collectionPoints)
  }
}
export default CollectionPointRegisterPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.collection-points{
  .q-item{
    min-height: 42px!important;
    border-radius: 3px;
  }
}

.card-row > div {
  padding: 5px 10px;
}

.card-row > div:nth-child(odd) {
  background-color: $ice;
}
.new-area {
  margin-bottom: 20px;
}
.align-right {
  text-align: right;
}
.form-area {
  height: 320px;
  overflow: auto;
}
.no-border {
  border: none;
  background: none;
  cursor: pointer;
}
</style>
